<template>
	<div class="info-item">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>{{title}}</span>
		</div>
		<!-- <div style="padding-bottom: 5px;">
			<el-alert description="适用于企业、个体商户、事业单位等、通过营业执照、组织机构代码等"> </el-alert>
		</div> -->
		<div class="form-box" v-if="form">
			<el-form label-width="140px" ref="form" :model="form" size="small">
				<el-descriptions :column="2" :border="true" :colon="false" size="mini">
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="统一社会信息代码">
						<span class="info-val">{{form.tyShXxCode}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="企业名称">
						<span class="info-val">{{form.name}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="英文名称">
						<span class="info-val">{{form.englishName}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="企业简称">
						<span class="info-val">{{form.qyShort}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="组织机构代码">
						<span class="info-val">{{form.orgJgCode}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="认证地区">
						<span class="info-val">{{form.rzRegion}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="企业类型">
						<span class="info-val">{{form.qyTyoe}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="纳税人标识">
						<span class="info-val">{{form.taxpayerSign}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="注册国家/地区">
						<span class="info-val">{{form.country}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="法定代表人">
						<span class="info-val">{{form.legalPerson}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="注册资本(万)">
						<span class="info-val">{{form.zcCapital}}万</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="注册资本货币种类">
						<span class="info-val">{{currencyInfo.obj[form.zcCurrency]}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="建立日期">
						<span class="info-val">{{form.foundDate}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="详细地址">
						<span class="info-val">{{form.address}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="营业执照图附件">
						<!-- <div class="info-val" style="display:flex;justify-content: center;">
							<img style="height:80px" :src="imgHost+form.yyZzSrc" />
						</div> -->
						<el-tag v-if="!form.yyZzSrc" type="info">无附件 </el-tag>
						<el-link v-else :underline="false" :href="baseURL+form.yyZzSrc" target="_blank">
							<el-tag type="success">查看附件</el-tag>
						</el-link>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="经营范围">
						<span class="info-val">{{form.manageArea}}</span>
					</el-descriptions-item>
				</el-descriptions>
			</el-form>
		</div>
		<div v-else class="no-info-box">请补充相关信息</div>
	</div>
</template>

<script>
	import constant from '@/api/commons.js'
	export default {
		name: "ShowRegisterInfo",
		computed: {
			currencyInfo:function(){
				return this.$store.getters['app/currencyInfo'];
			},
		},
		props:['title','form'],
		data() {
			return {
				imgHost:process.env.VUE_APP_BASE_API,
				tableData: [],
				qyTyoes: constant.qyTyoes,
				countrys: constant.country,
				count: 0,
				fileName: '',
				zcCurrencys: [],
			};
		},
		mounted() {
			console.log(this.currencyInfo)
		},
		methods: {
		}
	};
</script>
<style scoped="scoped">
</style>
